export default "__VITE_ASSET__CCrosL32__"